import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/payment/example-qr.svg'


const _hoisted_1 = { class: "inline-flex justify-center mt-6" }
const _hoisted_2 = { class: "relative py-3 inline-flex justify-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  height: "250",
  width: "250",
  src: _imports_0,
  alt: "qr-code"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Klik untuk muat ulang ")
const _hoisted_5 = { class: "inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogPaymentLayoutHeader = _resolveComponent("DialogPaymentLayoutHeader")!
  const _component_reload = _resolveComponent("reload")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_DialogPaymentLayoutButton = _resolveComponent("DialogPaymentLayoutButton")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DialogPaymentLayoutHeader, { textHeader: _ctx.titleMessage }, {
      "sub-header": _withCtx(() => [
        _withDirectives(_createVNode("p", null, null, 512), [
          [_directive_sanitize_html, _ctx.captionMessage]
        ])
      ]),
      _: 1
    }, 8, ["textHeader"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        class: "h-6",
        alt: "payment-logo",
        src: 
        require(`@/app/ui/assets/svg/payment/${_ctx.paymentMethod?.logo}-active.svg`)
      
      }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reGenerateQr && _ctx.reGenerateQr(...args))),
        class: "cursor-pointer absolute bg-red-lp-100 p-1 px-8 text-center text-12px text-white justify-center items-center flex flex-col",
        style: {"width":"135px","height":"135px","border-radius":"50%","top":"50%","left":"50%","transform":"translate(-50%, -50%)"}
      }, [
        _createVNode(_component_reload, { class: "h-8 mb-3" }),
        _hoisted_4
      ])
    ]),
    _createVNode(_component_DialogPaymentLayoutButton, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_button_outline, {
            onClick: _ctx.cancelQrPayment,
            title: "Kembali",
            custom: "w-44",
            style: {"height":"40px"}
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ], 64))
}